import React from 'react';
import { TIERS, TIER_META } from '../../../util/coachTier';
import css from './TierBadge.css';

/**
 * Small inline tier badge — diamond shape with tier-specific gradient.
 * Renders nothing for NETWORK_MEMBER (baseline tier shows no badge).
 *
 * Usage:
 *   <TierBadge tier="established" />
 *   <TierBadge tier="master_coach" size="lg" showLabel />
 */
export default function TierBadge({ tier, size = 'md', showLabel = false, className = '' }) {
  const meta = TIER_META[tier];
  if (!meta || !meta.showBadge) return null;

  const isMaster = tier === TIERS.MASTER_COACH;

  return (
    <span
      className={`${css.badge} ${css[`size_${size}`]} ${isMaster ? css.badgeIridescent : ''} ${className}`}
      title={meta.label}
      aria-label={meta.label}
    >
      <span className={css.diamond} style={{ background: meta.color }} aria-hidden="true" />
      {showLabel && (
        <span className={css.label} style={{ color: meta.color }}>
          {meta.label.toUpperCase()}
        </span>
      )}
    </span>
  );
}
